<template>
  <div>
    <CkEditorFormGroup
        v-model="data.content"
        name="content"
        label="Content"
        :error="(errors.content || [])[0]"
    />
  </div>
</template>

<script>
import CkEditorFormGroup from "../../../../vendor/forms/FormGroups/Block/CkEditor.vue";

export default {
  components: {CkEditorFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
